import React from "react";
import not_found_img from "./img/not-found.png";
import { useTranslation } from "react-i18next";

export const NotFoundPlug = () => {
  const { t } = useTranslation();

  return (
    <div className="notFoundContainer col-12 d-flex flex-column align-items-center justify-content-center bg-white rounded-1">
      <img
        className="mb-3 mb-md-5"
        src={not_found_img}
        alt="not found picture"
      />
      <h3 className="mb-3 text-dark fw-bold">
        {t("projects.No Results Found")}
      </h3>
      <p className="text-gray fs-7 text-center">
        {t("projects.Sorry, we couldn’t find what you’re looking for.")}{" "}
        <span className="d-block">
          {t("projects.Please try to use different terms.")}
        </span>
      </p>
    </div>
  );
};
